/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Comment } from './comment';
import { ShareDto } from './shareDto';
import { Build } from './build';
import { StringTimespan } from './stringTimespan';
import { ParameterData } from './parameterData';


export interface TT4SensorAdminDto { 
    idDevice?: number;
    id?: number;
    insertTs?: string;
    updateTs?: string;
    deviceTypeId?: string;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    parameterDataList?: Array<ParameterData>;
    warranty?: string;
    testDevice?: boolean;
    userSubsystemVisibility?: Array<boolean>;
    batteryTimeline?: Array<StringTimespan>;
    pcbTypeId?: string;
    gpsPlusDevice?: boolean;
    buildInProduction?: Build;
    currentBuild?: Build;
    previousBuilds?: Array<Build>;
    comments?: Array<Comment>;
    replacedById?: number;
    nfcTagUid?: string;
    replaces?: number;
    name?: string;
    shares?: Array<ShareDto>;
    orderName?: string;
    deviceManufacturingStatus?: TT4SensorAdminDto.DeviceManufacturingStatusEnum;
    trapIds?: Array<number>;
    _class: string;
}
export namespace TT4SensorAdminDto {
    export const DeviceManufacturingStatusEnum = {
        New: 'New',
        Assigned: 'Assigned',
        ReadyForTest: 'ReadyForTest',
        Testing: 'Testing',
        ManufacturingCompleted: 'ManufacturingCompleted',
        Packed: 'Packed',
        Shipped: 'Shipped',
        Canceled: 'Canceled',
        ManufacturingFailed: 'ManufacturingFailed'
    } as const;
    export type DeviceManufacturingStatusEnum = typeof DeviceManufacturingStatusEnum[keyof typeof DeviceManufacturingStatusEnum];
}


